export const badWords = [
  "porn",
  "gay",
  "adult",
  "sex",
  "fuck",
  "shit",
  "damn",
  "hell",
  "asshole",
  "bitch",
  "bastard",
  "crap",
  "dick",
  "douche",
  "fag",
  "motherfucker",
  "prick",
  "pussy",
  "nigger",
  "chink",
  "spic",
  "kike",
  "gook",
  "wetback",
  "cracker",
  "cunt",
  "slut",
  "whore",
  "skank",
  "dyke",
  "tranny",
  "kill",
  "murder",
  "rape",
  "beat",
  "attack",
  "retard",
  "idiot",
  "moron",
  "dumb",
];
